<template>
  <div class="share-box-component">
    <div class="social-buttons part">
      <FacebookShare :currentUser="currentUser" :score="score" :referralUrl="referralUrl" />
      <TwitterShare :currentUser="currentUser" :score="score" :referralUrl="referralUrl" />
      <EmailShare :currentUser="currentUser" :score="score" :referralUrl="referralUrl" />
    </div>
    <div class="referral-url part" @click="handleCopy">
      <i class="fa fa-copy"></i>
      <input type="text" readonly :value="referralUrl" ref="referralInput" size="30" />
      <div :class="{ hidden: !copied }" class="copied">Copied!</div>
    </div>
  </div>
</template>

<script>
import FacebookShare from "@/components/shared/FacebookShare";
import TwitterShare from "@/components/shared/TwitterShare";
import EmailShare from "@/components/shared/EmailShare";
import { parse } from "url";
export default {
  components: { FacebookShare, TwitterShare, EmailShare },
  props: ["score", "currentUser"],
  data() {
    return {
      copied: false
    };
  },
  computed: {
    referralUrl() {
      const ref = this.currentUser ? `?ref=${this.currentUser.uid}` : "";
      const pathName = parse(location.href).pathname;
      return location.origin + pathName + ref;
    }
  },
  methods: {
    handleCopy() {
      this.$refs.referralInput.select();
      document.execCommand("copy");
      this.copied = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.hidden {
  opacity: 0;
}

.share-box-component {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  height: 100%;
  padding: 0px;
  .part {
    margin: 10px 0;
    width: 100%;
  }
  .header {
    .title {
      font-size: 1.5rem;
    }
  }

  .referral-url {
    margin-bottom: 5px;
    cursor: pointer;
    position: relative;
    i,
    svg {
      margin-right: 10px;
      font-size: 1.5rem;
    }
    input {
      margin-top: 5px !important;
      cursor: pointer;
      text-align: center;
      font-size: 0.7rem !important;
      outline: none;
      padding: 15px 25px;
      margin: 0 5px;
      font-family: inherit;
      font-size: inherit;
      box-sizing: border-box;
      max-width: 95%;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 12px;
      color: white;
      border: none;
    }
    .copied {
      text-align: center;
      font-size: 0.625rem;
    }
  }

  .play-again {
    a {
      cursor: pointer;
    }
  }

  p {
    font-size: 0.625rem;
  }
}

@media (max-width: 768px) {
  .share-box-component {
    .referral-url {
      input {
        max-width: 75%;
      }
    }
  }
  .social-buttons {
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 320px) {
  .end-game-screen {
    .header {
      .title {
        font-size: 1.2rem;
      }
    }
  }

  .end-game-screen .referral-url {
    input {
      max-width: 80%;
      font-size: 0.9rem;
      padding: 10px 6px;
    }
  }
}
</style>
